export default __webpack_public_path__ + "static/media/Camerron-1Open.aa71bbaf.jpg";